import { type FC, lazy, useMemo, type JSX } from 'react';

import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

const ProRoot = lazy(async () => await import('./pro/ProRoot'));
const EventsRoot = lazy(async () => await import('./events/EventsRoot'));
const WaitingRoomRoot = lazy(
    async () => await import('./waitingRoom/WaitingRoomRoot'),
);

const App: FC<{ appName: Configuration.AppName }> = ({ appName }) => {
    const App: JSX.Element = useMemo(() => {
        switch (appName) {
            case env.Pro.appName:
                return <ProRoot />;
            case env.WaitingRoom.appName:
                return <WaitingRoomRoot />;
            case env.Events.appName:
                return <EventsRoot />;
        }
    }, [appName]);

    const router = createBrowserRouter([
        {
            path: '*',
            element: App,
        },
    ]);

    return <RouterProvider router={router} />;
};

export default App;
